
import React from 'react';
import { ViewState } from '../types';

interface FooterProps {
  onNavigate: (view: ViewState) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="w-full py-8 px-4 border-t border-white/5 bg-black/20 no-print">
      <div className="container mx-auto max-w-6xl flex flex-col items-center gap-6">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-[10px] uppercase tracking-[0.2em] font-bold text-gray-500">
          <button onClick={() => onNavigate('privacy')} className="hover:text-gold-400 transition-colors">Privacy Policy</button>
          <button onClick={() => onNavigate('coppa')} className="hover:text-gold-400 transition-colors">COPPA Policy</button>
          <button onClick={() => onNavigate('support')} className="hover:text-gold-400 transition-colors">Support</button>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-[10px] uppercase tracking-[0.15em] font-bold text-gray-600">
          <span className="text-gray-500">Resources:</span>
          <button onClick={() => onNavigate('blog-how-it-works')} className="hover:text-gold-400 transition-colors">How It Works</button>
          <button onClick={() => onNavigate('blog-best-apps')} className="hover:text-gold-400 transition-colors">Best Story Apps</button>
          <button onClick={() => onNavigate('blog-screen-free')} className="hover:text-gold-400 transition-colors">Screen-Free Routine</button>
          <button onClick={() => onNavigate('blog-safety-guide')} className="hover:text-gold-400 transition-colors">AI Safety Guide</button>
        </div>
        
        <p className="text-[10px] text-gray-600 text-center max-w-md leading-relaxed">
          &copy; {new Date().getFullYear()} StoryForge Kids. Built with love for the next generation of dreamers. 
          All AI-generated content is filtered for safety and quality.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
